import { Injectable } from "@angular/core";
import { AngularFireList, AngularFireDatabase } from '@angular/fire/database';
import { BehaviorSubject, Subject, Observable } from 'rxjs';
import { AngularFireStorage, AngularFireUploadTask } from 'angularfire2/storage';
import { filter, finalize, map } from "rxjs/operators";
import { LoadingController, ModalController } from '@ionic/angular';
import { SharedService } from '../sheared/sharedService.service';
import { authenticationService } from '../Authentication/authentication.service';
import { CotationService } from './cotation.service';
import { url } from 'inspector';
import { isUndefined } from 'util';
import { FactoryService } from "../historique/factory.service";
import { AssureurService } from "../Assureur/assureur.service";


@Injectable({
  providedIn: 'root'
})


export class CotationAutoService {

  loading2: HTMLIonLoadingElement
  LesCategoriesAuto = new BehaviorSubject<any[]>([]);
  task: AngularFireUploadTask;
  items_imguploaded_auto: any[]=[]
  private codeAssur

  //  private surprime=[
  //   {Code_Categorie:'201',Code_Sous_Categorie:'1',Surprime_Passager:6190,Place_limite:5},
  //   {Code_Categorie:'201',Code_Sous_Categorie:'2',Surprime_Passager:6190,Place_limite:5},
  //   {Code_Categorie:'202',Code_Sous_Categorie:'2',Surprime_Passager:6190,Place_limite:8},
  //   {Code_Categorie:'202',Code_Sous_Categorie:'3',Surprime_Passager:6190,Place_limite:8},
  //   {Code_Categorie:'203',Code_Sous_Categorie:'2',Surprime_Passager:5440,Place_limite:8},
  //   {Code_Categorie:'203',Code_Sous_Categorie:'3',Surprime_Passager:5440,Place_limite:8}
  //  ]

  private BaremeTamporaire = [
    { Jour_Min: 1, Jour_Max: 4, Taux_Prime: 10 }, { Jour_Min: 5, Jour_Max: 10, Taux_Prime: 15 },
    { Jour_Min: 11, Jour_Max: 20, Taux_Prime: 21 }, { Jour_Min: 21, Jour_Max: 30, Taux_Prime: 28 },
    { Jour_Min: 31, Jour_Max: 59, Taux_Prime: 36 }, { Jour_Min: 60, Jour_Max: 89, Taux_Prime: 44 },
    { Jour_Min: 90, Jour_Max: 119, Taux_Prime: 52 }, { Jour_Min: 120, Jour_Max: 149, Taux_Prime: 60 },
    { Jour_Min: 150, Jour_Max: 179, Taux_Prime: 68 }, { Jour_Min: 180, Jour_Max: 209, Taux_Prime: 76 },
    { Jour_Min: 210, Jour_Max: 239, Taux_Prime: 84 }, { Jour_Min: 240, Jour_Max: 269, Taux_Prime: 92 },
    { Jour_Min: 270, Jour_Max: 366, Taux_Prime: 100 }
  ]

  primeBaseAnnuelle = new BehaviorSubject<any[]>([]);
  primeDommage = new BehaviorSubject<any[]>([]);
  primeValmain = new BehaviorSubject<any[]>([]);
  primeIncendie = new BehaviorSubject<any[]>([]);
  primeVol = new BehaviorSubject<any[]>([]);
  ListAccessoire = new BehaviorSubject<any[]>([]);
  EnregistrementOk = new BehaviorSubject<boolean>(false);
  private identityAss:any



  constructor(private db: AngularFireDatabase, private storage: AngularFireStorage,
    private sharedService: SharedService, private authentic: authenticationService,
    private _assur:AssureurService,
    private _fact:FactoryService,
    private loadingController: LoadingController) {

    this.getaccessoires()
    this.codeAssur=this._fact.getData(201)

  }



  async loadCategorie() {
    this.loading2 = await this.loadingController.create({
      message: 'Chargement...',
      mode:"ios",
      duration: 30000,
      spinner: 'bubbles'
    });

    await this.loading2.present();

    await this.db.list("CategoriesAuto/200", ref => ref.orderByChild("Libelle_Categorie"))
      .snapshotChanges(['child_added']).subscribe(
        (actions) => {

          const catego = [];
          actions.forEach((action) => {
          const lstSous=[]

            for (const key in action.payload.exportVal().sous_cat) {
              if (Object.prototype.hasOwnProperty.call(action.payload.exportVal().sous_cat, key)) {
                const element = action.payload.exportVal().sous_cat[key];
                lstSous.push({
                  Code_Sous_cate: element.Code_Sous_cate,
                   Libelle_Sous_cat:element.Libelle_Sous_cat
                })
              }
            }

            catego.push({
              Code_Cat: action.payload.exportVal().Code_Cat,
              Libelle_Categorie: action.payload.exportVal().Libelle_Categorie,
              Taxe: action.payload.exportVal().Taxe,
              icon: action.payload.exportVal().icon,
              sous_cat:lstSous //action.payload.exportVal().sous_cat

            });
          })
          this.loading2.dismiss()
          this.LesCategoriesAuto.next(catego)

        }
      )
  }


  async Tarif_RC(codeAss, itemObj) {
    switch (codeAss) {
      case '1000': //NSIA
          if (itemObj.Code_Cat==="205") {
            itemObj.energ="E"
          } else if (itemObj.Code_Cat==="214"){
            itemObj.typeCLi=1
          }else  if (itemObj.Code_Cat==="209" && (itemObj.sous_cat==2 || itemObj.sous_cat==17)){
            itemObj.energ="D"
          }
        break;

      default:
        break;
}
this.primeBaseAnnuelle.next([])

    await this.db.list(`TarifAuto/${codeAss}/${itemObj.Code_Cat}/${itemObj.sous_cat}/${itemObj.energ}`, ref => ref.orderByChild("Code_Type")
      .equalTo(itemObj.typeCLi))
      .snapshotChanges(['child_added']).subscribe(
        (actions) => {
          const result = [];
          
          let rc= actions.find(e => (
            e.payload.exportVal().Code_Statut == itemObj.status &&  
            e.payload.exportVal().Puissance_Minimum <= itemObj.puiss && 
            e.payload.exportVal().Puissance_Maximum >= itemObj.puiss &&
            e.payload.exportVal().Nombre_Place_Minimum <= itemObj.place &&  
            e.payload.exportVal().Nombre_Place_Maximum >= itemObj.place
            ))
            if (typeof(rc)!=="undefined") {
              result.push({
                Prime: rc.payload.exportVal().Prime
              });
            }
      
          this.primeBaseAnnuelle.next(result)

        }
      )
  }
  async Tarif_Dommage(codeAss, itemObj) {
    if ("201 202 203 204 205".includes(itemObj.Code_Cat)) {
        if (itemObj.Code_Cat==="205") {
          itemObj.typeCLi="2"
          itemObj.sous_cat="7"
          itemObj.status=0
        } else {
          itemObj.typeCLi = "1"
        }
      
    }
    await this.db.list(`TarifDom/${codeAss}`, ref => ref.orderByChild("Code_Cat")
      .equalTo(itemObj.Code_Cat))
      .snapshotChanges(['child_added']).subscribe(
        (actions) => {
          const result = [];
          let dm=  actions.filter((action) => 
             action.payload.exportVal().Age_min <= itemObj.age &&
              action.payload.exportVal().Age_max >= itemObj.age &&
              action.payload.exportVal().typeCLi == itemObj.typeCLi &&
              action.payload.exportVal().sous_cat == itemObj.sous_cat &&
              action.payload.exportVal().Code_Statut == itemObj.status )
                if (typeof(dm)!=="undefined") {
                  dm.forEach(e =>{
                    result.push({
                      Libel_Sous_garantie: e.payload.exportVal().Libel_Sous_garantie,
                      Taux: e.payload.exportVal().Taux * 1
      
                    });
                  })
            
                }   

                this.primeDommage.next(result)
          }
      )
     
  }
  async Tarif_Incendie(codeAss, itemObj) {
    // if ("201 202 203 204".includes(itemObj.Code_Cat)) {
    //   itemObj.typeCLi="1"
    // }
    if (itemObj.Code_Cat==="205") {
      itemObj.typeCLi="2"
      itemObj.sous_cat="7"
      itemObj.status=0
    } 
    await this.db.list(`TarifInc/${codeAss}`, ref => ref.orderByChild("Code_Cat")
      .equalTo(itemObj.Code_Cat))
      .snapshotChanges(['child_added']).subscribe(
        (actions) => {
          const result = [];
       let ic= actions.find((action) => 
              (action.payload.exportVal().Age_min <= itemObj.age &&
              action.payload.exportVal().Age_max >= itemObj.age &&
              action.payload.exportVal().typeCLi == itemObj.typeCLi &&
              action.payload.exportVal().sous_cat == itemObj.sous_cat &&
              action.payload.exportVal().Code_Statut == itemObj.status))
                if (typeof(ic)!=="undefined") {
                  result.push({
                    Libel_Sous_garantie: ic.payload.exportVal().Libel_Sous_garantie,
                    Taux: ic.payload.exportVal().Taux * 1
    
                  });
                }  
         
              this.primeIncendie.next(result)
            }
      )
  }
  async Tarif_Vol(codeAss, itemObj) {
    if ("201 202 203 204 205".includes(itemObj.Code_Cat)) {
      if (itemObj.Code_Cat==="205") {
        itemObj.typeCLi="2"
        itemObj.sous_cat="7"
        itemObj.status=0
      } else {
        itemObj.typeCLi = "1"
      }
    }
    await this.db.list(`TarifVol/${codeAss}`, ref => ref.orderByChild("Code_Cat")
      .equalTo(itemObj.Code_Cat))
      .snapshotChanges(['child_added']).subscribe(
        (actions) => {
          const result = [];
        let vl= actions.find((action) => 
             (action.payload.exportVal().Age_min <= itemObj.age &&
              action.payload.exportVal().Age_max >= itemObj.age &&
              action.payload.exportVal().typeCLi == itemObj.typeCLi &&
              action.payload.exportVal().sous_cat == itemObj.sous_cat &&
              action.payload.exportVal().Code_Statut == itemObj.status) )

              if (typeof(vl)!=="undefined") {
                result.push({
                  Libel_Sous_garantie: vl.payload.exportVal().Libel_Sous_garantie,
                  Taux: vl.payload.exportVal().Taux * 1
  
                });
              }  
       
              this.primeVol.next(result)

            }

      )
  }
  async Tarif_Volmain(codeAss, itemObj) {
    itemObj.typeCLi = "1"
    await this.db.list(`TarifVolmain/${codeAss}`, ref => ref.orderByChild("Code_Cat")
      .equalTo(itemObj.Code_Cat))
      .snapshotChanges(['child_added']).subscribe(
        (actions) => {
          const result = [];
       let vm= actions.find((action) => 
             (action.payload.exportVal().Age_min <= itemObj.age &&
              action.payload.exportVal().Age_max >= itemObj.age &&
              action.payload.exportVal().Valeur_V_Min <= itemObj.valVenale &&
              action.payload.exportVal().Valeur_V_Max >= itemObj.valVenale &&
              action.payload.exportVal().typeCLi == itemObj.typeCLi &&
              action.payload.exportVal().sous_cat == itemObj.sous_cat &&
              action.payload.exportVal().Code_Statut == itemObj.status))

              if (typeof(vm)!=="undefined") {
                result.push({
                  Libel_Sous_garantie: vm.payload.exportVal().Libel_Sous_garantie,
                  Taux: vm.payload.exportVal().Taux * 1
  
                });
              } 
         
              this.primeValmain.next(result)
            }

          )

  }







  calculAgeVehicule(_objet: any) {
    let value : number | string
    value = isNaN(Math.round(this.sharedService.diffDays(_objet.dateMise, new Date()) / 365)) ? 'En cours' : Math.round(this.sharedService.diffDays(_objet.dateMise, new Date()) / 365)
    return value
  }
  private calculSurprimePlace(_objet: any): number {
    let value = 0
    // if ("201 202 203".includes(_objet.Code_Cat)) {
    //       this.surprime.forEach(e =>{
    //         if (e.Code_Categorie==_objet.Code_Cat && e.Code_Sous_Categorie==_objet.sous_cat && _objet.place>e.Place_limite ) {
    //                 value=(_objet.place-e.Place_limite)*1*e.Surprime_Passager
    //         }
    //        })
    // } else if(_objet.Code_Cat=="204") {

    // }

    return value
  }
  calculSurprimeChauffeur(_objet: any, e: any): number {
    let value = 0
    if ("201 202 203 205".includes(_objet.Code_Cat) && e.valider) {
      if (_objet.Code_Cat==="205") {
        e.place_limit=2
      }

      value = e.prime + (_objet.place - e.place_limit) * e.surprime

      // PersonnesTrans.forEach(e =>{
      //       if (e.valider) {
      //           value=e.prime + (_objet.place - e.place_limit) * e.surprime                
      //       }
      // })
    } else if (_objet.Code_Cat == "204") {

    }

    return value
  }
  calculTVL(_objet: any): number {
    let value
    // console.log(this.sharedService.diffDays("2019-07-14",_objet.dateImat));
    if ("201" != _objet.Code_Cat) return 0
    if (_objet.puiss <= 10) return 0
    if (this.sharedService.diffDays("2019-07-14", _objet.dateImat) < 0) return 0
    if (_objet.diplo != 2) return 0
    if (_objet.Anciensous == 0 || isUndefined(_objet.Anciensous)) return 0

    //if ("3"==_objet.sous_cat ) return 0
    if (this.calculAgeVehicule(_objet) <= 5) {
      value = (_objet.puiss - 10) * 20000
    } else {
      value = (_objet.puiss - 10) * 30000
    }
    return value
  }
  calculAccessoire(_objetNette: any): any {
    //Définir ici les acccessoires de ASAPASSUR
    let myacc=1500


    _objetNette.acc3 = 0; _objetNette.acc6 = 0; _objetNette.acc12 = 0
    this.ListAccessoire.subscribe((access) => {
      if (access) {
        _objetNette.acc3 = (_objetNette.prime3 != 0) ? access.filter(a => a.min <= _objetNette.prime3 && a.max >= _objetNette.prime3)[0].acc+myacc : 0
        _objetNette.acc6 = (_objetNette.prime6 != 0) ? access.filter(a => a.min <= _objetNette.prime6 && a.max >= _objetNette.prime6)[0].acc+myacc : 0
        _objetNette.acc12 = (_objetNette.prime12 != 0) ? access.filter(a => a.min <= _objetNette.prime12 && a.max >= _objetNette.prime12)[0].acc+myacc : 0

      }

    })
    return _objetNette
  }
  calculTaxes(_objetNette: any, tauxTaxe: number): any {

    //#region TAXE ENREGISTREMENT
    _objetNette.Taxe3 = Math.round((_objetNette.prime3 + _objetNette.acc3) * tauxTaxe / 100)
    _objetNette.Taxe6 = Math.round((_objetNette.prime6 + _objetNette.acc6) * tauxTaxe / 100)
    _objetNette.Taxe12 = Math.round((_objetNette.prime12 + _objetNette.acc12) * tauxTaxe / 100)
    //#endregion
    //#region TAXE CSS
    _objetNette.css3 = Math.round((_objetNette.prime3 + _objetNette.acc3) / 100)
    _objetNette.css6 = Math.round((_objetNette.prime6 + _objetNette.acc6) / 100)
    _objetNette.css12 = Math.round((_objetNette.prime12 + _objetNette.acc12) / 100)
    //#endregion
    return _objetNette
  }

  calculPrimeDuree(prime: number, laperiode: any[]): any {
    /// SI offre promotionnelle
    // On applique ici la réduction promotionnelle de 8%
 this._assur.ListAssreurs.pipe(
  map(items => items.find(e => e.CodeAssu== this._fact.getData(201)))
).subscribe(res => this.identityAss=res)

    let value = {
      mois3: "", prime3: 0, acc3: 0, Taxe3: 0, css3: 0, cartRose3: 0, Tvl3: 0, Ttc3: 0,
      mois6: "", prime6: 0, acc6: 0, Taxe6: 0, css6: 0, cartRose6: 0, Tvl6: 0, Ttc6: 0,
      mois12: "", prime12: 0, acc12: 0, Taxe12: 0, css12: 0, cartRose12: 0, Tvl12: 0, Ttc12: 0
    }



    for (let index = 0; index < laperiode.length; index++) {
      const element = laperiode[index];
      if (element) {
        if (element == "3 mois") {
          value.mois3 = element
          value.prime3 = Math.round((this.BaremeTamporaire.filter(a => a.Jour_Min <= 90 && a.Jour_Max >= 90)[0].Taux_Prime * prime / 100)*(1-this.identityAss.t3))
        } else if (element == "6 mois") {
          value.mois6 = element
          value.prime6 = Math.round((this.BaremeTamporaire.filter(a => a.Jour_Min <= 180 && a.Jour_Max >= 180)[0].Taux_Prime * prime / 100)*(1-this.identityAss.t6))
        } else if (element == "12 mois") {
          value.mois12 = element
          value.prime12 = Math.round(prime * (1-this.identityAss.t12)) 
          
        }
      }
    }


    return value

  }

  async calculPrimeRC_DR(_objet: any) {

    //#region Déterminer la prime de base annuelle
    await this.Tarif_RC(this.codeAssur, _objet)

    return await this.primeBaseAnnuelle



  }

  async calculPrimeInc(_objet: any) {
    await this.Tarif_Incendie(this.codeAssur, _objet)
    return await this.primeIncendie
  }
  async calculPrimeVol(_objet: any) {
    await this.Tarif_Vol(this.codeAssur, _objet)
    return await this.primeVol
  }
  async calculPrimeVolmain(_objet: any) {
    await this.Tarif_Volmain(this.codeAssur, _objet)
    return await this.primeValmain
  }
  async calculPrimeDommage(_objet: any) {
    await this.Tarif_Dommage(this.codeAssur, _objet)
    return await this.primeDommage
  }

  // AUTOMOBILE
  async instNewAuto(auto: any, codeAssur, $key: string) {
    this.authentic.profile.uid
    auto.type = "Auto"
    auto.CodeAssur = codeAssur
    auto.Quittance = $key
    await this.db.list(`Cotations/${this.authentic.profile.uid}/Auto`).push(auto)
    this.EnregistrementOk.next(true)
  }

  // async uploadFile2(fileup: any, repertoire: string) {

  //   var filePath = `${repertoire}/${new Date().getTime()}.jpeg`;
  //   const fileRef = this.storage.ref(filePath)
  //   ///fileRef.delete()
  //   return await fileRef.putString(fileup, 'data_url').percentageChanges


  // }

  uploadFile(fileup: any, repertoire: string,objetv:any,loader:HTMLIonLoadingElement) {

    var filePath = `${repertoire}/${new Date().getTime()}.jpeg`;
    const fileRef = this.storage.ref(filePath)
    const uploadTask=fileRef.putString(fileup, 'data_url')

    uploadTask.snapshotChanges().pipe(
      finalize(() => {
        fileRef.getDownloadURL().subscribe(url => {
          objetv.cartegrise = url;
          objetv.cartePath = filePath;
          const i = this.items_imguploaded_auto.length+1       
          this.items_imguploaded_auto.push({
            _path:filePath,
            _index:i
          })
          loader.dismiss()
        });
      })
    ).subscribe();
  
    return uploadTask.percentageChanges();

  }

  delete_image_load(){
     const i_max= this.items_imguploaded_auto.length
     this.items_imguploaded_auto.filter(e => e._index !== i_max).forEach( x =>{
       try {
        const fileRef = this.storage.ref(x._path)
        fileRef.delete()
       } catch (error) {
         
       }

     })
  }
  calculateImageSize(base64String) {
    let padding;
    let inBytes;
    let base64StringLength;
    
    if (base64String.endsWith('==')) { padding = 2; }
    else if (base64String.endsWith('=')) { padding = 1; }
    else { padding = 0; }

    base64StringLength = base64String.length;
    //console.log(base64StringLength);
    inBytes = (base64StringLength / 4) * 3 - padding;
    //console.log(inBytes / 1000+'KB');
    return (inBytes / 1000);
  }


  convertiontaille(taille:number){
    let result=""
    const tailleString=taille.toString().split('.')[0].length
    if (tailleString === 3 ) {
        result=taille.toString()+' kB'
    } else if (tailleString === 4) {
        result= taille.toString().substring(0,1)+' MB'
    }else if (tailleString === 5) {
        result= taille.toString().substring(0,2)+' MB'
    }else if (tailleString === 6) {
        result= taille.toString().substring(0,3)+' MB'
    }else {
        result= "Erreur d'image..."
  }
  return result
  }



  private getaccessoires(codeAssur ?) {
    //+this.codeAssur
    this.db.list("Accessoires/1010", ref => ref.orderByValue()).snapshotChanges(['child_added']).subscribe(
      (actions) => {
        const ListAccessoire = [];
        actions.forEach((action) => {
          ListAccessoire.push({
            acc: action.payload.exportVal().acc,
            min: action.payload.exportVal().min,
            max: action.payload.exportVal().max
          });
        })
        this.ListAccessoire.next(ListAccessoire)
        //return ListAssreurs
      }
    )
  }


}



